<template>
  <div class="social">
    <p v-if="pageName">Share this {{ pageName }}</p>
    <div class="share-buttons">
      <a
        :href="`mailto:?body=${pageUrl}`"
        target="_blank"
        title="Share by Email"
        rel="noopener"
      >
        <MailCircleIcon />
      </a>
      <a
        :href="`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`"
        title="Share by Linkedin"
        target="_blank"
        rel="noopener"
        aria-label="linkedin link"
      >
        <LinkedInCircleIcon />
      </a>
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`"
        title="Share by Facebook"
        target="_blank"
        rel="noopener"
        aria-label="facebook link"
      >
        <FacebookCircleIcon />
      </a>
      <a
        :href="`https://twitter.com/intent/tweet?url=${pageUrl}`"
        title="Share by Twitter"
        target="_blank"
        rel="noopener"
        aria-label="twitter link"
      >
        <XIcon />
      </a>
    </div>
  </div>
</template>

<script>
import XIcon from '~/components/Common/Svg/Social/XIcon.vue';
import FacebookCircleIcon from '~/components/Common/Svg/FacebookCircleIcon.vue';
import LinkedInCircleIcon from '~/components/Common/Svg/LinkedInCircleIcon.vue';
import MailCircleIcon from '~/components/Common/Svg/Social/MailCircleIcon.vue';

export default {
  components: {
    XIcon,
    FacebookCircleIcon,
    LinkedInCircleIcon,
    MailCircleIcon,
  },
  props: {
    pageName: {
      type: String,
      default: '',
    },
  },
  computed: {
    pageUrl() {
      return `${process.env.hostUrl}${this.$route.path}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Social.scss';
</style>
